module.exports = __webpack_public_path__ + "static/media/sign-in-hero.0da1a42b.jpg";